import { IGridVodItem, isVodLeft, isVodPlaylist } from '../../types'
import { VodLeft, VodPlaylist } from '../../components/DynamicComponents'

export const gridVodItemToComponent = ({
  item,
  i,
}: {
  item: IGridVodItem
  i: number
}) => {
  const { grid_id } = item

  if (isVodLeft(item)) {
    return <VodLeft vodLeft={item} key={`${i} ${grid_id}`} />
  }
  if (isVodPlaylist(item)) {
    return <VodPlaylist vodPlaylist={item} key={grid_id} />
  }

  return null
}
